module.exports = __webpack_public_path__ + "assets/rider-app-white.e4b72e39.svg";